// extracted by mini-css-extract-plugin
export default {"form":"styles_form__a7e-l","button":"styles_button__9lGDs"};